export const LAUNCH_YEAR = 2017;

export function getYearsInBusiness(now: Date = new Date()): number {
  return now.getFullYear() - LAUNCH_YEAR;
}
